$(document).ready(function () {
  $(".b-description_readmore").moreLines({
    linecount: 3,
    baseclass: "b-description",
    basejsclass: "js-description",
    classspecific: "_readmore",
    buttontxtmore: "Lue lisää...",
    buttontxtless: "Piilota",
    animationspeed: 250,
  });
  $(".b-description_readmore_button").on("click", function (e) {
    if (!$(e.target).hasClass("b-description_readmore_button_active")) {
      $("html, body").animate({ scrollTop: 0 }, 0);
    }
  });
});
